import * as types from '../constants/ActionTypes';
import { delay } from 'redux-saga'
import { take, put, call, fork, cancel, select  } from 'redux-saga/effects'
import { getInterval } from '../components/Pitch/gameJson'
import * as sceneTypes from '../constants/SceneTypes'
import * as sounds from '../constants/Sounds'
import * as GameViewMode from '../constants/GameViewMode'

export const getGameSpeed = (state) => state.gameSpeed
export const getCurrentEvent = (state) => state.currentEvent
export const checkIfIsReplay = (state) => state.replay !== null
export const checkIfPaused = (state) => state.paused === true
export const showGoalReplays = (state) => window.PitchSettings.ShowGoalReplays
export const getGameViewMode = (state) => window.gameViewMode == null ? initGameViewModeFromUrl() : window.gameViewMode;

export function* playScenes(scenes, fromReplay) {
    for (var index = 0; index < scenes.length; index++) {
        let scene = scenes[index];
        yield put(scene)
        const action = yield take(types.END_SCENE);
        const showReplays = yield select(showGoalReplays)
        if(fromReplay !== true && action.type === types.END_SCENE && (scene.sceneType === sceneTypes.Goal || scene.sceneType === sceneTypes.OwnGoal) && showReplays)
            yield* showReplay()
    }
}

function* replayLoop(untilEvent) {
    while(true) {
        let gameSpeed = yield select(getGameSpeed)
        let currentEvent = yield select(getCurrentEvent)
        if(currentEvent >= untilEvent){
            return
        }
        let time = getInterval(currentEvent)
        if(time > 150) {
            yield put({ type: types.SET_GAME_SPEED, gameSpeed: 10 })
            yield put({ type: types.MOVE_TO_NEXT_EVENT })
            yield call(delay, 10 * time)
            yield put({ type: types.SET_GAME_SPEED, gameSpeed: gameSpeed })
            yield call(delay, 1000)
        }
        else {
            yield put({ type: types.MOVE_TO_NEXT_EVENT })
            yield call(delay, gameSpeed * time)
        }
    }
}

function* showReplay() {
    let currentEvent = yield select(getCurrentEvent);
    yield put({ type: types.START_REPLAY, from: currentEvent - getReplayBegining(currentEvent) })
    yield call(delay, 1000)
    yield* replayLoop(currentEvent)
    yield call(delay, 1000)
    yield put({ type: types.END_REPLAY })
}


export function playEventSounds(event) {
    if(event != null) {
        if(event.M == "1" || event.M == "3")
            window.SoundComponent.play(sounds.REF_HALFTIME);

        if(event.num == 1)
            window.SoundComponent.play(sounds.REF_START);

        if(event.L != null)
            window.SoundComponent.play(sounds.REF);
    }
}

export function lookingForGameScenes(event) {
    let scenes = [];

    if(event == null) {
        scenes.push(START_SCENE(sceneTypes.EndGame));
        return scenes;
    }

    if(event.G != null){
        scenes.push(START_SCENE(sceneTypes.Goal, event.G));
    }

    if(event.W != null){
        scenes.push(START_SCENE(sceneTypes.OwnGoal, event.W));
    }

    if(event.Y != null){
        scenes.push(START_SCENE(sceneTypes.YellowCard, event.Y));
    }

    if(event.R != null){
        scenes.push(START_SCENE(sceneTypes.RedCard, event.R));
    }

    if(event.O != null){
        scenes.push(START_SCENE(sceneTypes.Offside, event.O));
    }

    return scenes;
}

export function START_SCENE(type,sceneInfo) {
    return {
        type: types.START_SCENE,
        sceneType: type,
        event: sceneInfo
    }
}

function getReplayBegining(currentEvent) {
    let maxDuration = 7;
    let duration = 1;

    if(currentEvent - maxDuration > 0)
        return maxDuration;
    else
        return currentEvent;
}

function initGameViewModeFromUrl() {
    window.gameViewMode = getGameViewModeFromUrl();
    return window.gameViewMode;
}

function getGameViewModeFromUrl() {
    if(process.env.NODE_ENV == "development") {
        return GameViewMode.Full;
    }
    
    var query = window.location.hash.substring(2);
    if(query == "")
        return GameViewMode.Full;

    var gameModeParamValue = parse_query_string(query).gm;
    
    if(gameModeParamValue == null)
        return GameViewMode.Full;

    switch(gameModeParamValue){
        case "f":
            return GameViewMode.Full;
        case "e":
            return GameViewMode.Extended;
        case "k":
            return GameViewMode.KeyMoments;
        default:
            return GameViewMode.Full;
    }
}

function parse_query_string(query) {
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      var key = decodeURIComponent(pair[0]);
      var value = decodeURIComponent(pair[1]);
      // If first entry with this name
      if (typeof query_string[key] === "undefined") {
        query_string[key] = decodeURIComponent(value);
        // If second entry with this name
      } else if (typeof query_string[key] === "string") {
        var arr = [query_string[key], decodeURIComponent(value)];
        query_string[key] = arr;
        // If third or later entry with this name
      } else {
        query_string[key].push(decodeURIComponent(value));
      }
    }
    return query_string;
  }



/** WEBPACK FOOTER **
 ** ./src/sagas/common.js
 **/